var map = {
	"./pages/about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"pages-about-about-module"
	],
	"./pages/display/display.module": [
		"./src/app/pages/display/display.module.ts",
		"default~pages-display-display-module~pages-home-home-module~pages-manage-manage-module",
		"common",
		"pages-display-display-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"default~pages-display-display-module~pages-home-home-module~pages-manage-manage-module",
		"common",
		"pages-home-home-module"
	],
	"./pages/list/list.module": [
		"./src/app/pages/list/list.module.ts",
		"pages-list-list-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/manage/manage.module": [
		"./src/app/pages/manage/manage.module.ts",
		"default~pages-display-display-module~pages-home-home-module~pages-manage-manage-module",
		"common",
		"pages-manage-manage-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;